import React, { Children } from 'react';
import { ShieldCheck, AlertCircle, Heart, Award, Users, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function Benefits() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <section id="benefits" className="py-10 bg-white" data-id="element-20">
      <div className="container mx-auto px-4" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <motion.h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-800" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-23">
            Durante años,{' '}
            <span className="text-red-600 underline" data-id="element-24">te hicieron creer</span>{' '}
            que solo los medicamentos podían ayudarte
          </motion.h2>
          <motion.p className="text-xl text-gray-600 max-w-3xl mx-auto" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-25">
            Pero lo que no te cuentan es que el exceso de analgésicos puede
            empeorar tus crisis. Millones viven atrapados entre dolor… y efectos
            secundarios.
          </motion.p>
        </div>
        <motion.div className="bg-blue-50 p-6 rounded-xl mb-12 border-l-4 border-blue-500" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-26">
          <div className="flex items-start" data-id="element-27">
            <Award size={24} className="text-blue-600 mr-3 mt-1 flex-shrink-0" data-id="element-28" />
            <div data-id="element-29">
              <h3 className="font-bold text-lg mb-2" data-id="element-30">
                Respaldado por especialistas
              </h3>
              <p className="text-gray-700" data-id="element-31">
                Médicos y fisioterapeutas recomiendan nuestra terapia como
                alternativa efectiva a los medicamentos.
              </p>
            </div>
          </div>
        </motion.div>
        <motion.div className="text-center mb-12" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-32">
          <motion.div className="flex items-center justify-center space-x-3 mb-3" animate={{
          scale: [1, 1.03, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} data-id="element-33">
            <Users size={20} className="text-blue-600" data-id="element-34" />
            <p className="text-xl text-blue-600 font-semibold" data-id="element-35">
              Hoy, más de <span className="underline" data-id="element-36">12,000 personas</span> en
              17 países ya eligieron una alternativa natural
            </p>
          </motion.div>
          <p className="text-gray-600" data-id="element-37">
            Con resultados reales desde los primeros usos
          </p>
        </motion.div>
        <motion.div className="grid md:grid-cols-3 gap-10" variants={container} initial="hidden" animate="show" data-id="element-38">
          <motion.div className="bg-blue-50 p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow" variants={item} whileHover={{
          y: -5,
          transition: {
            duration: 0.2
          }
        }} data-id="element-39">
            <div className="flex justify-center mb-6" data-id="element-40">
              <ShieldCheck size={48} className="text-blue-600" data-id="element-41" />
            </div>
            <h3 className="text-xl font-bold mb-4 text-center" data-id="element-42">
              Sin medicamentos
            </h3>
            <p className="text-gray-600 text-center" data-id="element-43">
              Tratamiento completamente natural que trabaja con tu cuerpo, no
              contra él.
            </p>
            <div className="mt-4 bg-white p-2 rounded-lg text-sm flex items-center justify-center" data-id="element-44">
              <CheckCircle size={16} className="text-green-500 mr-2" data-id="element-45" />
              <span data-id="element-46">Evita efectos secundarios dañinos</span>
            </div>
          </motion.div>
          <motion.div className="bg-blue-50 p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow" variants={item} whileHover={{
          y: -5,
          transition: {
            duration: 0.2
          }
        }} data-id="element-47">
            <div className="flex justify-center mb-6" data-id="element-48">
              <AlertCircle size={48} className="text-blue-600" data-id="element-49" />
            </div>
            <h3 className="text-xl font-bold mb-4 text-center" data-id="element-50">Sin químicos</h3>
            <p className="text-gray-600 text-center" data-id="element-51">
              Deja de introducir sustancias extrañas en tu sistema y permite que
              tu cuerpo sane naturalmente.
            </p>
            <div className="mt-4 bg-white p-2 rounded-lg text-sm flex items-center justify-center" data-id="element-52">
              <CheckCircle size={16} className="text-green-500 mr-2" data-id="element-53" />
              <span data-id="element-54">Protege tu hígado y riñones</span>
            </div>
          </motion.div>
          <motion.div className="bg-blue-50 p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow" variants={item} whileHover={{
          y: -5,
          transition: {
            duration: 0.2
          }
        }} data-id="element-55">
            <div className="flex justify-center mb-6" data-id="element-56">
              <Heart size={48} className="text-blue-600" data-id="element-57" />
            </div>
            <h3 className="text-xl font-bold mb-4 text-center" data-id="element-58">Sin adicción</h3>
            <p className="text-gray-600 text-center" data-id="element-59">
              Rompe el ciclo de dependencia de los analgésicos y recupera tu
              libertad.
            </p>
            <div className="mt-4 bg-white p-2 rounded-lg text-sm flex items-center justify-center" data-id="element-60">
              <CheckCircle size={16} className="text-green-500 mr-2" data-id="element-61" />
              <span data-id="element-62">Recupera el control de tu vida</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}